// extracted by mini-css-extract-plugin
export default {"filterLabel":"ActivityTypes_filterLabel__A3Aq4"};